import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { resourceScopeCleared, userScopeCleared } from '@krp/client-runtime'

/** Намерение вкладки «Кассиры»: какой источник и кассир выбраны и что набрано в поиске. PIN и ответы службы сюда не попадают. */
export interface CashierAccessIntent { resourceId: string; cashierKey: string; sourceCashierId: string; search: string }
/** Что вкладка запоминает при уходе из окна: выбор источника и кассира, поиск; всё прочее — только строки. */
export function decodeCashierAccessIntent(raw: unknown): Partial<CashierAccessIntent> | undefined {
  if (typeof raw !== 'object' || raw === null) return undefined
  const value = raw as Record<string, unknown>
  const pick = (key: keyof CashierAccessIntent) => (typeof value[key] === 'string' ? { [key]: value[key] } : {})
  return { ...pick('resourceId'), ...pick('cashierKey'), ...pick('sourceCashierId'), ...pick('search') }
}
const initialState: CashierAccessIntent = { resourceId: '', cashierKey: '', sourceCashierId: '', search: '' }
const slice = createSlice({ name: 'cashierAccess', initialState, reducers: {
  cashierAccessPatched: (state, action: PayloadAction<Partial<CashierAccessIntent>>) => { Object.assign(state, action.payload) },
}, extraReducers: (builder) => {
  builder.addCase(userScopeCleared, () => initialState)
  builder.addCase(resourceScopeCleared, (state, action) => (state.resourceId === action.payload.resourceId ? initialState : state))
} })
export const { cashierAccessPatched } = slice.actions
export const cashierAccessReducer = slice.reducer
